// EE TODO: remove eslint-disable comment
/* eslint-disable */
import React from "react";
import { useSelector } from "react-redux";

import { getLillyCopayFormInitialValues } from "./form/initialValues";
import { SaveButton } from "../../header";
import useBaseEEConfiguration from "../../hooks/useBaseEEConfiguration";
import { applyTrimFields } from "../../utils/updateFormData";
import renderReactFromJson from "../../utils/renderReactFromJson";
import formJson from "./form/LillyCopayFormJson.json";
import { CompleteFormButton } from "../../CompleteFormButton";
import { HEADER_SUBMIT_BUTTON_TYPES } from "../../constants";
import { selectCurrentApplication, selectSelectedAssistanceProgramById } from "../../../../../store/selector";
import { dateFormatter } from "../../../../../utils/date";
import { EEsignatureStatuses } from "../../../../../constant/EEsignatureStatuses";

// Function to process template variables in form JSON
const processTemplateVariables = (json, variables) => {
  const processedJson = JSON.parse(JSON.stringify(json)); // Deep clone

  const processObject = (obj) => {
    if (typeof obj === "string") {
      let processedString = obj;
      Object.entries(variables).forEach(([key, value]) => {
        const template = `{{${key}}}`;
        processedString = processedString.replaceAll(template, value || "");
      });
      return processedString;
    } else if (Array.isArray(obj)) {
      return obj.map(processObject);
    } else if (obj && typeof obj === "object") {
      const processedObj = {};
      Object.entries(obj).forEach(([key, value]) => {
        processedObj[key] = processObject(value);
      });
      return processedObj;
    }
    return obj;
  };

  return processObject(processedJson);
};

const sanitizePathSegment = (value) => {
  if (!value) return "";
  return value
    .toLowerCase()
    .trim() // Remove leading/trailing whitespace first
    .replace(/[^a-z0-9\s-]/g, "") // Remove special characters, keep alphanumeric, spaces, and hyphens
    .replace(/[\s_]+/g, "-") // Replace spaces and underscores with single hyphen
    .replace(/-+/g, "-"); // Collapse multiple hyphens to single hyphen
};

export const useLillyCopayConfiguration = () => {
  const vendorName = "lilly";
  const eePlanType = "copay";
  const rootPath = "application_form_editor.lilly.copay"; //EE TODO: add data to src/locales/translations/en/ApplicationFormEditor.js

  const currentApplication = useSelector(selectCurrentApplication);
  const selectedAssistanceProgramById = useSelector(selectSelectedAssistanceProgramById);

  const drugName = currentApplication?.approvedRxnormDrugs?.[0].bnName;
  const genericDrug = currentApplication?.approvedRxnormDrugs?.[0].pinName;
  const templateName = currentApplication.ApplicationFormConfigurationTemplateName;
  const apPid = selectedAssistanceProgramById?.pid;
  const termsAndConditionsLink =
    templateName && apPid && drugName
      ? `https://public-assets.tailormed.co/express_enroll/${sanitizePathSegment(templateName)}/${sanitizePathSegment(
          apPid
        )}/${sanitizePathSegment(drugName)}/terms-and-conditions.pdf`
      : "";

  // Template variables to replace in form JSON
  const templateVariables = {
    drugDisplayName: currentApplication.drugDisplayName,
    genericDrug,
    termsAndConditionsLink
  };

  // Process the form JSON with template variables
  const processedFormJson = processTemplateVariables(formJson, templateVariables);

  const baseConfig = useBaseEEConfiguration({ vendorName, eePlanType, rootPath, formJson: processedFormJson });

  const lillySpecificConfig = {
    activeFormSection: "",
    getFormInitialValues: ({ applicationForm }) =>
      getLillyCopayFormInitialValues({ applicationForm, formJson: processedFormJson }),
    getFormFromJson: (form) => renderReactFromJson(form, processedFormJson),
    saveButton: (props) => (
      <SaveButton onSave={(form) => applyTrimFields(form)} id={"EE_lilly_copay_save_form"} {...props} />
    ),
    afterSubmissionPayload: () => ({}),
    applicationFormHeaderSubmission: (props) => <CompleteFormButton id={"EE_complete_button"} {...props} />,
    headerSubmitButtonType: HEADER_SUBMIT_BUTTON_TYPES.SUBMIT_FORM,
    getEnrollResultData: ({ application, t }) => ({
      bin: application.bin,
      pcn: application.pcn,
      group: application.group,
      member_id: application.memberId,
      expiration_date: application.effectiveIndefinitely
        ? t("patientApplications.valid_indefinitely")
        : dateFormatter(application.validThrough) || "--"
    }),
    getAdditionalResultCardInformation: false,
    getApprovedResultDescription: () => <></>,
    getShowEnrollResult: (applicationForm) => applicationForm?.status === EEsignatureStatuses.SUBMITTED,
    patientAlreadyEnrolledText: (t, phoneNumber) =>
      t("patientApplications.enroll.enroll_result.lilly_patient_already_enrolled", {
        phoneNumber
      })
  };

  return {
    ...baseConfig,
    ...lillySpecificConfig
  };
};

export default useLillyCopayConfiguration;
